function veda_fn_936c75ffc269421b9fa21931a4763e5c () {
      
  if (window.veda_fn_936c75ffc269421b9fa21931a4763e5cCleanup === undefined) {
    window.veda_fn_936c75ffc269421b9fa21931a4763e5cCleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_936c75ffc269421b9fa21931a4763e5cCleanup.cleanup();

      try {
        const uniqueId = "id_6081ab8a-2c7b-45ed-bb6d-299bef6780cc";
        const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
        containers.forEach(container => {
          if (!container) {
            return;
          }
          veda.plugins.videoCover(container);
          const { animatedSlider } = veda.plugins;

const slider = animatedSlider(container.querySelector(".veda-animated-slider"));

window.veda_fn_936c75ffc269421b9fa21931a4763e5cCleanup.push(() => {
  slider.destroy();
});
        });
      } catch(error) {
        console.error(error);
      }
    }
veda_fn_936c75ffc269421b9fa21931a4763e5c();